import {
  CLEAR_SEARCH
} from "../constants";

export const clearSearchList = () => (dispatch: any) => {
  dispatch({ type: CLEAR_SEARCH });
}